import * as React from 'react'
import type { SVGProps } from 'react'
const SvgDownloadSimple = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M12 13.5V3" stroke="#039874" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M20.25 13.5V19.5H3.75V13.5" stroke="#039874" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M15.75 9.75L12 13.5L8.25 9.75" stroke="#039874" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
  
)
export default SvgDownloadSimple
